import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  constructor() { }
  @Input() layout: number | string | undefined;
  @Input() logo: number | string | undefined;
  @Input() bg: number | string | undefined;

  ngOnInit(): void {
  }

}
